module.exports = __webpack_public_path__ + "media/images/btn_station_booking_creation-1c10f08b05916c22cfd65a6fdd42d070.gif";